// import {
//    Card,
//    Flex,
//    Text,
//    Button,
//    Box,
//    Input,
//    Select,
//    useColorModeValue,
//    useBreakpointValue,
//    useOutsideClick,
//    useDisclosure,
// } from '@chakra-ui/react';
// import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { motion } from 'framer-motion';
// import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
// import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';

// // UI
// import Menu from 'components/menu/MainMenu';
// import DynamicDataTable from '../../masters/components/DynamicDataTable';

// import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
// import { SearchIcon } from '@chakra-ui/icons';

// import { useFilterData, downloadPDF, downloadExcel } from '../../../../utils/DataTableUtils';
// import { deleteRecord } from '../../../../utils/util';
// import SalesDetails from 'components/salesDetails/SalesDetails';
// import TransactionDetailModal from 'views/admin/masters/components/TransactionDetailModel';

// // ACTION
// import {
//    getPurchaseInvoice,
//    getPurchaseInvoices,
//    deletePurchaseInvoice,
//    emptyPurchase,
//    getSinglePurchaseWithPrevAndNext,
//    updateSyncPurchaseInvoice,
// } from '../../../../redux/actions/purchaseInvoice';
// import { getAccountById } from '../../../../redux/actions/account';

// import { useDispatch } from 'react-redux';
// import { useUser } from 'contexts';
// import SalesInvoiceFilterModal from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceFilterModal';
// import { IoFilterOutline } from 'react-icons/io5';
// import { AiTwotoneBook } from 'react-icons/ai';
// import { IoMdArrowRoundBack } from 'react-icons/io';

// const columnHelper = createColumnHelper();
// const MotionFlex = motion(Flex);
// const MotionSearchIcon = motion(SearchIcon);

// const UnusedPurchaseInvoiceMaster = () => {
//    const textColor = useColorModeValue('secondaryGray.900', 'white');
//    const bg = useColorModeValue('#f2f7f2', '#1a254b');
//    const icon = useColorModeValue('#000000', '#ffffff');
//    const backgroundColor = useColorModeValue('#ECFCFF', '#101F4A');
//    const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
//    const navigate = useNavigate();
//    const dispatch = useDispatch();
//    const { user } = useUser();
//    const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
//    const { isOpen, onOpen, onClose } = useDisclosure();
//    const {
//       isOpen: isBillToBillModal,
//       onOpen: onOpenBillToBillModal,
//       onClose: onCloseBillToBillModal,
//    } = useDisclosure();
//    const purchaseInvoice = useSelector((state) => state.purchaseInvoice?.list || []);
//    const Totals = useSelector((state) => state.purchaseInvoice.pagination.totals);
//    //    const totalCount = useSelector((state) => state.purchaseInvoice.totalCount);
//    //    const isLoading = useSelector((state) => state.purchaseInvoice.isLoading);
//    const pagination = useSelector((state) => state.purchaseInvoice?.pagination);
//    const totalCount = useSelector((state) => state.purchaseInvoice?.totalCount);
//    const singleEntity = useSelector((state) => state?.purchaseInvoice?.single || {});
//    const daybookTypeData = useSelector(
//       (state) => state.purchaseInvoice?.pagination?.totals?.TotalDaybookBalance || null,
//    );
//    const viewData = useSelector((state) => state?.purchaseInvoice?.purchaseData);
//    const account = useSelector((state) => state.account.single);
//    const [currentPage, setCurrentPage] = useState(1);
//    const [limit, setLimit] = useState(10);
//    const [data, setData] = useState([]);
//    const [isEditingPage, setIsEditingPage] = useState(false);
//    const [pageInputValue, setPageInputValue] = useState('');
//    const [searchQuery, setSearchQuery] = useState('');
//    const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
//    const [expanded, setExpanded] = useState(false);
//    const [isOpenSingleView, setIsOpenSingleView] = useState(false);
//    const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
//    const [isDropdownOpen, setDropdownOpen] = useState(false);
//    const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
//    const [paginateData, setPaginateData] = useState({});
//    const Admin = user?.isAdmin;
//    const [accountId, setAccountId] = useState(null);
//    const [companyId, setCompanyId] = useState(null);
//    const [invoiceData, setInvoiceData] = useState(null);
//    const purchaseInvoiceRight = Array.isArray(user?.userRights)
//       ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchaseinvoice
//       : null;

//    const { viewDetail, paginate } = useMemo(() => {
//       const data = viewData?.data[0];
//       const pagination = viewData?.pagination;
//       return { viewDetail: data, paginate: pagination };
//    }, [viewData?.data, viewData?.pagination]);

//    const [columnVisibility, setColumnVisibility] = useState({
//       docno: true,
//       transactionAt: true,
//       daybookname: true,
//       accountname: true,
//       qty1: false,
//       qty2: false,
//       qty3: false,
//       taxableAmount: true,
//       gstAmount: true,
//       netAmount: true,
//       pendingamt: true,
//       pendingstatus: true,
//       createdu: false,
//       updatedu: false,
//       status: false,
//       action: true,
//    });
//    const [sorting, setSorting] = useState([]);

//    const columnsData = useMemo(
//       () => [
//          { id: 'docno', header: 'DOC NO', accessor: 'docno' },
//          { id: 'transactionAt', header: 'DOC Date', accessor: 'transactionAt' },
//          { id: 'partyNo', header: 'Bill No', accessor: 'partyNo' },
//          { id: 'partyDate', header: 'Bill Date', accessor: 'partyDate' },
//          { id: 'daybookname', header: 'Daybook', accessor: 'daybookname' },
//          { id: 'accountname', header: 'Party', accessor: 'accountname' },
//          { id: 'qty1', header: 'Qty 1', accessor: 'qty1' },
//          { id: 'qty2', header: 'Qty 2', accessor: 'qty2' },
//          { id: 'qty3', header: 'Qty 3', accessor: 'qty3' },
//          {
//             id: 'taxableAmount',
//             header: (
//                <Box>
//                   <Text>Taxable Amount</Text>
//                   {Totals?.totalTaxableAmount > 0 && (
//                      <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
//                         (₹{' '}
//                         {
//                            Totals.totalTaxableAmount
//                               .toLocaleString('en-IN', {
//                                  minimumFractionDigits: 2,
//                                  maximumFractionDigits: 2,
//                               })
//                               .split('.')[0]
//                         }
//                         <Text as="span" fontSize="0.8em" verticalAlign="baseline">
//                            .{Totals.totalTaxableAmount.toFixed(2).split('.')[1]}
//                         </Text>
//                         )
//                      </Text>
//                   )}
//                </Box>
//             ),
//             accessor: 'taxableAmount',
//          },
//          {
//             id: 'gstAmount',
//             header: 'GST',
//             accessor: 'gstAmount',
//          },
//          {
//             id: 'netAmount',
//             header: (
//                <Box>
//                   <Text>Net Amount</Text>
//                   {Totals?.totalNetAmount > 0 && (
//                      <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
//                         (₹{' '}
//                         {
//                            Totals.totalNetAmount
//                               .toLocaleString('en-IN', {
//                                  minimumFractionDigits: 2,
//                                  maximumFractionDigits: 2,
//                               })
//                               .split('.')[0]
//                         }
//                         <Text as="span" fontSize="0.8em" verticalAlign="baseline">
//                            .{Totals.totalNetAmount.toFixed(2).split('.')[1]}
//                         </Text>
//                         )
//                      </Text>
//                   )}
//                </Box>
//             ),
//             accessor: 'netAmount',
//          },
//          {
//             id: 'pendingamt',
//             header: (
//                <Box>
//                   <Text>Pending Amount</Text>
//                   {Totals?.totalPendingAmount > 0 && (
//                      <Text fontSize="xs" color="gray.500" display="inline-flex" alignItems="baseline">
//                         (₹{' '}
//                         {
//                            Totals.totalPendingAmount
//                               .toLocaleString('en-IN', {
//                                  minimumFractionDigits: 2,
//                                  maximumFractionDigits: 2,
//                               })
//                               .split('.')[0]
//                         }
//                         <Text as="span" fontSize="0.8em" verticalAlign="baseline">
//                            .{Totals.totalPendingAmount.toFixed(2).split('.')[1]}
//                         </Text>
//                         )
//                      </Text>
//                   )}
//                </Box>
//             ),
//             accessor: 'pendingamt',
//          },
//          {
//             id: 'pendingstatus',
//             header: 'Payment Status',
//             accessor: 'pendingstatus',
//          },
//          { id: 'createdu', header: 'Created By', accessor: 'createdu' },
//          { id: 'updatedu', header: 'Updated By', accessor: 'updatedu' },
//          { id: 'status', header: 'STATUS', accessor: 'status' },
//       ],
//       [],
//    );
//    const [filters, setFilters] = useState({
//       pendingstatus: 'all',
//       invoiceBook: 'all',
//       duration: 'any',
//       contact: '',
//       item: '',
//       daybookId: '',
//       daybookIds: '',
//       accountIds: '',
//       accountId: '',
//       fromDate: '',
//       toDate: '',
//    });

//    const handleApplyFilters = (newFilters) => {
//       setFilters(newFilters);
//       let count = 0;
//       if (newFilters.pendingstatus !== 'all') count++;
//       if (newFilters.invoiceBook !== 'all') count++;
//       if (newFilters.duration !== 'any') count++;
//       if (newFilters.contact) count++;
//       if (newFilters.item) count++;
//       if (newFilters.daybookId) count++;
//       if (newFilters.daybookIds) count++;
//       if (newFilters.accountIds) count++;
//       if (newFilters.accountId) count++;
//       if (newFilters.fromDate) count++;
//       if (newFilters.toDate) count++;
//       setCurrentPage(1);
//    };
//    const columns = columnsData
//       .filter((column) => columnVisibility[column.id])
//       ?.map((column) =>
//          columnHelper.accessor(column.id, {
//             id: column.id,
//             header: () => (
//                <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
//                   {column.header}
//                </Text>
//             ),
//             cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
//          }),
//       );

//    const table = useReactTable({
//       data,
//       columns,
//       state: { sorting },
//       onSortingChange: setSorting,
//       getCoreRowModel: getCoreRowModel(),
//       getSortedRowModel: getSortedRowModel(),
//    });

//    const wrapperRef = useRef();

//    const filteredData = useFilterData(data, debouncedSearchQuery, columns);

//    const handlePageChange = useCallback(
//       (directionOrPage) => {
//          if (typeof directionOrPage === 'number') {
//             setCurrentPage(directionOrPage);
//          } else {
//             setCurrentPage((prevPage) => {
//                if (directionOrPage === 'next') {
//                   return prevPage < pagination?.totalPages ? prevPage + 1 : prevPage;
//                } else {
//                   return prevPage > 1 ? prevPage - 1 : prevPage;
//                }
//             });
//          }
//       },
//       [pagination?.totalPages],
//    );

//    function EditSyncRecord(id) {
//       let formdata = {
//          id,
//          status: true,
//       };
//       const sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
//       const sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
//       dispatch(updateSyncPurchaseInvoice(formdata)).then(() => {
//          dispatch(
//             getPurchaseInvoices({
//                page: currentPage,
//                limit: limit,
//                search: debouncedSearchQuery,
//                companyId: user?.loginhistory?.companyId,
//                sortBy,
//                sortOrder,
//                paymentStatus: filters.paymentStatus !== 'all' ? filters.paymentStatus : undefined,
//                invoiceBook: filters.invoiceBook !== 'all' ? filters.invoiceBook : undefined,
//                duration: filters.duration !== 'any' ? filters.duration : undefined,
//                contact: filters.contact || undefined,
//                item: filters.item || undefined,
//                daybookId: filters.daybookId || undefined,
//                daybookIds: filters.daybookIds || undefined,
//                accountIds: filters.accountIds || undefined,
//                accountId: filters.accountId || undefined,
//                fromDate: filters.fromDate || undefined,
//                toDate: filters.toDate || undefined,
//                status: false, // Keep this to only show unsynced records
//                isSync: true,
//             }),
//          );
//       });
//    }

//    const handlePageClick = () => {
//       setIsEditingPage(true);
//       setPageInputValue(''); // Clear input value when starting to edit
//    };

//    const handlePageInputSubmit = () => {
//       const page = parseInt(pageInputValue);
//       if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
//          handlePageChange(page);
//       }
//       setIsEditingPage(false);
//       setPageInputValue('');
//    };

//    const handlePageInputBlur = () => {
//       handlePageInputSubmit();
//    };

//    const handlePageKeyDown = (e) => {
//       if (e.key === 'Enter') {
//          handlePageInputSubmit();
//       } else if (e.key === 'Escape') {
//          setIsEditingPage(false);
//          setPageInputValue('');
//       }
//    };

//    const handlePageSizeChange = (e) => {
//       const value = e.target.value;
//       const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);
//       setLimit(newLimit);
//       setCurrentPage(1);
//    };

//    const deletePurchase = () => {
//       deleteRecord(viewDetail?.id, deletePurchaseInvoice, dispatch);
//       onClose();
//    };
//    const handleViewSingleData = async (id) => {
//       await dispatch(getPurchaseInvoice(id));
//       setIsOpenSingleView(true);

//       const currentIdx = purchaseInvoice.findIndex((x) => x.id === id);
//       const prevObject = currentIdx > 0 ? purchaseInvoice[currentIdx - 1] : null;
//       const nextObject = currentIdx < purchaseInvoice.length - 1 ? purchaseInvoice[currentIdx + 1] : null;

//       await dispatch(
//          getSinglePurchaseWithPrevAndNext({
//             id: id,
//             page: 1,
//             limit: 1,
//             sortBy: 'id',
//             sortOrder: 'desc',
//          }),
//       );
//       setPaginateData({
//          hasPreviousPage: prevObject ? true : false,
//          previousPage: prevObject ? currentIdx - 1 : null,
//          nextPage: nextObject ? currentIdx + 1 : null,
//          hasNextPage: nextObject ? true : false,
//       });
//       onOpen();
//    };

//    const handlePrevPage = useCallback(
//       async (page) => {
//          await dispatch(
//             getSinglePurchaseWithPrevAndNext({
//                page: page,
//                limit: 1,
//                sortBy: 'id',
//                sortOrder: 'desc',
//             }),
//          );
//       },
//       [dispatch],
//    );
//    const handleNextPage = useCallback(
//       async (page) => {
//          await dispatch(
//             getSinglePurchaseWithPrevAndNext({
//                page: page,
//                limit: 1,
//                sortBy: 'id',
//                sortOrder: 'desc',
//             }),
//          );
//       },
//       [dispatch],
//    );

//    const toggleDropdown = () => {
//       setDropdownOpen(!isDropdownOpen);
//    };

//    const handleOnClose = useCallback(() => {
//       dispatch(emptyPurchase());
//       onClose(true);
//    }, [dispatch, onClose]);

//    const handleOnCloseBillToBill = useCallback(() => {
//       setAccountId(null);
//       setCompanyId(null);
//       onCloseBillToBillModal();
//    }, [onCloseBillToBillModal]);

//    const getPurchase = useCallback(async () => {
//       if (user && user?.loginhistory?.companyId) {
//          let sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
//          let sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
//          await dispatch(
//             getPurchaseInvoices({
//                page: currentPage,
//                limit: limit,
//                search: debouncedSearchQuery,
//                companyId: user?.loginhistory?.companyId,
//                sortBy,
//                sortOrder,
//                // Add filter parameters here
//                paymentStatus: filters.paymentStatus !== 'all' ? filters.paymentStatus : undefined,
//                invoiceBook: filters.invoiceBook !== 'all' ? filters.invoiceBook : undefined,
//                duration: filters.duration !== 'any' ? filters.duration : undefined,
//                contact: filters.contact || undefined,
//                item: filters.item || undefined,
//                daybookId: filters.daybookId || undefined,
//                daybookIds: filters.daybookIds || undefined,
//                accountIds: filters.accountIds || undefined,
//                accountId: filters.accountId || undefined,
//                fromDate: filters.fromDate || undefined,
//                toDate: filters.toDate || undefined,
//                status: false,
//                isSync: true,
//             }),
//          );
//       }
//    }, [
//       currentPage,
//       dispatch,
//       filters.accountId,
//       filters.contact,
//       filters.fromDate,
//       filters.toDate,
//       filters.daybookId,
//       filters.daybookIds,
//       filters.accountIds,
//       filters.duration,
//       filters.invoiceBook,
//       filters.item,
//       filters.paymentStatus,
//       limit,
//       debouncedSearchQuery,
//       sorting,
//       user,
//    ]);

//    useOutsideClick({
//       ref: wrapperRef,
//       handler: () => {
//          if (debouncedSearchQuery === '') setExpanded(false);
//       },
//    });

//    useEffect(() => {
//       getPurchase();
//    }, [getPurchase]);

//    useEffect(() => {
//       if (account) {
//          const details = [
//             { label: 'Bill To', value: account?.name || '-' },
//             { label: 'Mobile', value: account?.mobile || '-' },
//             { label: 'PAN', value: account?.panNo || '-' },
//             { label: 'Billing Address', value: account?.address || '-' },
//          ];
//          setDynamicUserDetails(details);
//       }
//    }, [account]);

//    useEffect(() => {
//       if (isOpenSingleView) {
//          // dispatch(getAccountById({ id: singleEntity?.accountId, compId: user?.loginhistory?.companyId }));
//       }
//    }, [dispatch, isOpenSingleView, singleEntity?.accountId, user?.loginhistory?.companyId]);

//    useEffect(() => {
//       setPaginateData(paginate);
//    }, [paginate]);

//    useEffect(() => {
//       setData(purchaseInvoice);
//       return () => {};
//    }, [purchaseInvoice]);

//    const debounce = (func, delay) => {
//       let timer;
//       return function (...args) {
//          clearTimeout(timer);
//          timer = setTimeout(() => func.apply(this, args), delay);
//       };
//    };

//    const debouncedSearchHandler = React.useCallback(
//       debounce((query) => {
//          setDebouncedSearchQuery(query);
//       }, 500),
//       [],
//    );

//    const handleSearchChange = (e) => {
//       const value = e.target.value;
//       setSearchQuery(value);
//       debouncedSearchHandler(value);
//    };

//    return (
//       <>
//          <Card
//             flexDirection="column"
//             w="100%"
//             px="0px"
//             overflowX={{ sm: 'scroll', lg: 'hidden' }}
//             position="relative"
//             py="10px"
//             mt="2%"
//             bg={backgroundColor}>
//             <Flex
//                width={{ base: '100%', md: 'auto' }}
//                mb="8px"
//                px={{ base: '1px', md: '25px' }}
//                justifyContent="space-between"
//                align="center"
//                overflowX="auto"
//                flexWrap="nowrap"
//                gap={3}>
//                <Flex align="center" gap={4} flexShrink={0}>
//                   <Link to="/admin/utility">
//                      <Button>
//                         <IoMdArrowRoundBack size={18} />
//                      </Button>
//                   </Link>
//                   <Text
//                      color={textColor}
//                      ml={{ base: '8px', md: 0 }}
//                      fontSize={{ base: '17px', lg: '22px' }}
//                      fontWeight="700"
//                      lineHeight="100%">
//                      Synced Un-Approved Entry
//                   </Text>
//                </Flex>

//                <Flex align="center" gap={2} flexShrink={0}>
//                   <Box cursor={'pointer'} onClick={onFilterOpen}>
//                      <IoFilterOutline size={22} />
//                   </Box>
//                   <Box cursor={'pointer'} onClick={() => navigate('/admin/purchase/invoice/managedaybook')}>
//                      <AiTwotoneBook size={22} />
//                   </Box>
//                   {/* Pagination Controls */}
//                   <Flex align="center" flexShrink={0}>
//                      <Box
//                         onClick={() => handlePageChange('prev')}
//                         cursor={currentPage > 1 ? 'pointer' : 'not-allowed'}
//                         opacity={currentPage > 1 ? 1 : 0.5}
//                         role="button"
//                         aria-label="Previous page">
//                         <MdNavigateBefore size={28} />
//                      </Box>

//                      {/* Current Page Display with Manual Input */}
//                      <Flex align="center" mx="10px" position="relative">
//                         {!isEditingPage ? (
//                            <Flex align="center">
//                               <Text
//                                  as="span"
//                                  fontSize={{ base: '14px', lg: '17px' }}
//                                  minWidth="40px"
//                                  textAlign="center"
//                                  onClick={handlePageClick}
//                                  cursor="pointer"
//                                  border="2px solid"
//                                  borderColor="blue.500"
//                                  color="blue.600"
//                                  fontWeight="medium"
//                                  px={2}
//                                  py={1}
//                                  borderRadius="md"
//                                  _hover={{ bg: 'blue.50' }}>
//                                  {currentPage}
//                               </Text>
//                               <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
//                                  /
//                               </Text>
//                               <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
//                                  {pagination?.totalPages || 1}
//                               </Text>
//                            </Flex>
//                         ) : (
//                            <Flex align="center">
//                               <Input
//                                  type="number"
//                                  min={1}
//                                  max={pagination?.totalPages || 1}
//                                  value={pageInputValue}
//                                  onChange={(e) => setPageInputValue(e.target.value)}
//                                  onBlur={handlePageInputBlur}
//                                  onKeyDown={handlePageKeyDown}
//                                  fontSize={{ base: '14px', lg: '17px' }}
//                                  width="40px"
//                                  textAlign="center"
//                                  p={0}
//                                  border="2px solid"
//                                  borderColor="blue.500"
//                                  _focus={{ outline: 'none', ring: '1px', ringColor: 'blue.500' }}
//                                  autoFocus
//                               />
//                               <Text as="span" fontSize={{ base: '14px', lg: '17px' }} mx={1}>
//                                  /
//                               </Text>
//                               <Text as="span" fontSize={{ base: '14px', lg: '17px' }}>
//                                  {pagination?.totalPages || 1}
//                               </Text>
//                            </Flex>
//                         )}
//                      </Flex>

//                      {/* Next Page Button */}
//                      <Box
//                         onClick={() => handlePageChange('next')}
//                         cursor={currentPage < (pagination?.totalPages || 1) ? 'pointer' : 'not-allowed'}
//                         opacity={currentPage < (pagination?.totalPages || 1) ? 1 : 0.5}
//                         role="button"
//                         aria-label="Next page">
//                         <MdNavigateNext size={28} />
//                      </Box>
//                   </Flex>

//                   {/* Page Size Select */}
//                   <Select
//                      width="auto"
//                      h={{ base: 9, lg: 10 }}
//                      marginRight="5"
//                      value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
//                      onChange={(e) => {
//                         const newLimit = e.target.value === 'ALL' ? totalCount : Number(e.target.value);
//                         setLimit(newLimit);
//                         setCurrentPage(1); // Reset to first page when changing page size
//                      }}>
//                      <option value="10">10</option>
//                      <option value="20">20</option>
//                      <option value="30">30</option>
//                      <option value="ALL">All</option>
//                   </Select>

//                   {/* Search Field */}
//                   <MotionFlex
//                      ref={wrapperRef}
//                      align="center"
//                      bg={bg}
//                      borderRadius="full"
//                      cursor="pointer"
//                      px={expanded ? 3 : 0}
//                      w={expanded ? '200px' : '40px'}
//                      h="40px"
//                      transition="all 0.3s ease"
//                      onClick={() => setExpanded(true)}>
//                      <MotionSearchIcon
//                         color={icon}
//                         animate={{ rotate: expanded ? 0 : 90 }}
//                         transition={{ duration: 0.3 }}
//                         style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
//                      />
//                      {expanded && (
//                         <Input
//                            variant="unstyled"
//                            placeholder="Search..."
//                            color={icon}
//                            value={searchQuery}
//                            onChange={handleSearchChange}
//                            autoFocus
//                         />
//                      )}
//                   </MotionFlex>

//                   {/* Download + Column Visibility Menu */}
//                   <Menu
//                      onDownloadPDF={downloadPDF}
//                      onDownloadExcel={downloadExcel}
//                      columnVisibility={columnVisibility}
//                      setColumnVisibility={setColumnVisibility}
//                   />
//                </Flex>

//                {isMobileOrTablet && (Admin || purchaseInvoiceRight?.add) && (
//                   <Box position="fixed" bottom="4" right="4" zIndex={999}>
//                      <Button
//                         onClick={() => navigate('/admin/purchase/invoice/add')}
//                         variant="darkBrand"
//                         color="white"
//                         fontSize="sm"
//                         fontWeight="500"
//                         borderRadius="full"
//                         p={{ base: '4', lg: '5' }}
//                         boxShadow="lg">
//                         Add New
//                      </Button>
//                   </Box>
//                )}
//             </Flex>
//             <Text display="flex" alignContent="center" justifyContent="center" borderTop="1px solid #ccc">
//                {daybookTypeData?.map(
//                   (item, i) =>
//                      item.totalTaxableAmount !== 0 && (
//                         <React.Fragment key={i}>
//                            <Text as="span" color={item.totalTaxableAmount > 0 ? 'green.500' : 'red.500'}>
//                               {item.daybookname} : {item.totalTaxableAmount} {item.totalTaxableAmount > 0 ? 'DB' : 'CR'}
//                            </Text>
//                            {i < daybookTypeData.length - 1 && (
//                               <Text as="span" mx="1">
//                                  |
//                               </Text>
//                            )}
//                         </React.Fragment>
//                      ),
//                )}
//             </Text>

//             <DynamicDataTable
//                singleEntityRights={purchaseInvoiceRight}
//                table={table}
//                tableData={data}
//                emptyMessage="No Purchase Invoice data found"
//                handleViewSingleData={handleViewSingleData}
//                toggleDropdown={toggleDropdown}
//                onEditClick={(row) => {
//                   EditSyncRecord(row.id);
//                }}
//                onDeleteClick={(id) => {
//                   deleteRecord(id, deletePurchaseInvoice, dispatch);
//                }}
//                onBillToBillClick={(row) => {
//                   setAccountId(row.accountId);
//                   setCompanyId(row.companyId);
//                   setInvoiceData(row);
//                   onOpenBillToBillModal();
//                }}
//                canDelete={true}
//                columnVisibility={columnVisibility}
//             />
//          </Card>

//          <SalesDetails
//             isOpen={isOpen}
//             onClose={handleOnClose}
//             title="Purchase Invoice"
//             entityType="purchaseinvoice"
//             singleEntity={singleEntity}
//             setIsEditFormOpen={setIsEditFormOpen}
//             setIsOpenSingleView={setIsOpenSingleView}
//             isEditFormOpen={isEditFormOpen}
//             handlePrevPage={handlePrevPage}
//             handleNextPage={handleNextPage}
//             paginate={paginateData}
//             viewDetail={viewDetail}
//             lineItems={viewDetail?.lineitems}
//             billTerms={viewDetail?.purchasebillteams}
//             onDelete={deletePurchase}
//             handleSerchClose={() => console.log('')}
//          />

//          {/* Filter Modal */}
//          <SalesInvoiceFilterModal
//             entityType="purchaseinvoice"
//             isOpen={isFilterOpen}
//             onClose={onFilterClose}
//             onApplyFilters={handleApplyFilters}
//             initialFilters={filters}
//             Totals={Totals}
//          />
//          <TransactionDetailModal
//             isOpen={isBillToBillModal}
//             onClose={handleOnCloseBillToBill}
//             accountId={accountId}
//             companyId={companyId}
//             invoiceData={invoiceData}
//             type="PURCHASE"
//             page={currentPage}
//             limit={limit}
//          />
//       </>
//    );
// };

// export default UnusedPurchaseInvoiceMaster;

import {
   Card,
   Flex,
   Text,
   Button,
   Box,
   Input,
   Select,
   useColorModeValue,
   useBreakpointValue,
   useOutsideClick,
   useDisclosure,
   useColorMode,
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';

// UI
import Menu from 'components/menu/MainMenu';
import DynamicDataTable from '../../masters/components/DynamicDataTable';

import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';

import { useFilterData, downloadPDF, downloadExcel } from '../../../../utils/DataTableUtils';
import { deleteRecord } from '../../../../utils/util';
import SalesDetails from 'components/salesDetails/SalesDetails';
import TransactionDetailModal from 'views/admin/masters/components/TransactionDetailModel';

// ACTION
import {
   getPurchaseInvoice,
   getPurchaseInvoices,
   deletePurchaseInvoice,
   emptyPurchase,
   getSinglePurchaseWithPrevAndNext,
   updateSyncPurchaseInvoice,
} from '../../../../redux/actions/purchaseInvoice';
import { getAccountById } from '../../../../redux/actions/account';

import { useDispatch } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import SalesInvoiceFilterModal from 'views/admin/sales/Pages/SalesInvoiceMaster/SalesInvoiceFilterModal';
import { IoFilterOutline } from 'react-icons/io5';
import { AiTwotoneBook } from 'react-icons/ai';
import { IoMdArrowRoundBack } from 'react-icons/io';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const UnusedPurchaseInvoiceMaster = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { user } = useUser();
   const { userGlobalSettingsData } = useGlobal();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const {
      isOpen: isBillToBillModal,
      onOpen: onOpenBillToBillModal,
      onClose: onCloseBillToBillModal,
   } = useDisclosure();
   const purchaseInvoice = useSelector((state) => state.purchaseInvoice?.list || []);
   const Totals = useSelector((state) => state.purchaseInvoice.pagination.totals);
   const pagination = useSelector((state) => state.purchaseInvoice?.pagination);
   const totalCount = useSelector((state) => state.purchaseInvoice?.totalCount);
   const singleEntity = useSelector((state) => state?.purchaseInvoice?.single || {});
   const daybookTypeData = useSelector(
      (state) => state.purchaseInvoice?.pagination?.totals?.TotalDaybookBalance || null,
   );
   const viewData = useSelector((state) => state?.purchaseInvoice?.purchaseData);
   const account = useSelector((state) => state.account.single);
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const [data, setData] = useState([]);
   console.log('data', data);

   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [expanded, setExpanded] = useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = useState(false);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isDropdownOpen, setDropdownOpen] = useState(false);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [paginateData, setPaginateData] = useState({});
   const Admin = user?.isAdmin;
   const [accountId, setAccountId] = useState(null);
   const [companyId, setCompanyId] = useState(null);
   const [invoiceData, setInvoiceData] = useState(null);
   const purchaseInvoiceRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchaseinvoice
      : null;

   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData?.data[0];
      const pagination = viewData?.pagination;
      return { viewDetail: data, paginate: pagination };
   }, [viewData?.data, viewData?.pagination]);

   const [columnVisibility, setColumnVisibility] = useState({
      docno: true,
      transactionAt: true,
      daybookname: true,
      accountname: true,
      qty1: false,
      qty2: false,
      qty3: false,
      taxableAmount: true,
      gstAmount: true,
      netAmount: true,
      pendingamt: true,
      pendingstatus: true,
      createdu: false,
      updatedu: false,
      status: false,
      action: true,
   });
   const [sorting, setSorting] = useState([]);

   const columnsData = useMemo(
      () => [
         { id: 'docno', header: 'DOC NO', accessor: 'docno' },
         { id: 'transactionAt', header: 'DOC Date', accessor: 'transactionAt' },
         { id: 'partyNo', header: 'Bill No', accessor: 'partyNo' },
         { id: 'partyDate', header: 'Bill Date', accessor: 'partyDate' },
         { id: 'daybookname', header: 'Daybook', accessor: 'daybookname' },
         { id: 'accountname', header: 'Party', accessor: 'accountname' },
         { id: 'qty1', header: 'Qty 1', accessor: 'qty1' },
         { id: 'qty2', header: 'Qty 2', accessor: 'qty2' },
         { id: 'qty3', header: 'Qty 3', accessor: 'qty3' },
         {
            id: 'taxableAmount',
            header: (
               <div>
                  <Text>Taxable Amount</Text>
                  {Totals?.totalTaxableAmount > 0 && (
                     <div className="inline-flex items-baseline text-xs text-gray-500">
                        (₹{' '}
                        {
                           Totals.totalTaxableAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        <span className="text-[0.8em] align-baseline">
                           .{Totals.totalTaxableAmount.toFixed(2).split('.')[1]}
                        </span>
                        )
                     </div>
                  )}
               </div>
            ),
            accessor: 'taxableAmount',
         },
         {
            id: 'gstAmount',
            header: 'GST',
            accessor: 'gstAmount',
         },
         {
            id: 'netAmount',
            header: (
               <div>
                  <Text>Net Amount</Text>
                  {Totals?.totalNetAmount > 0 && (
                     <div className="inline-flex items-baseline text-xs text-gray-500">
                        (₹{' '}
                        {
                           Totals.totalNetAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        <span className="text-[0.8em] align-baseline">
                           .{Totals.totalNetAmount.toFixed(2).split('.')[1]}
                        </span>
                        )
                     </div>
                  )}
               </div>
            ),
            accessor: 'netAmount',
         },
         {
            id: 'pendingamt',
            header: (
               <div>
                  <Text>Pending Amount</Text>
                  {Totals?.totalPendingAmount > 0 && (
                     <div className="inline-flex items-baseline text-xs text-gray-500">
                        (₹{' '}
                        {
                           Totals.totalPendingAmount
                              .toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })
                              .split('.')[0]
                        }
                        <span className="text-[0.8em] align-baseline">
                           .{Totals.totalPendingAmount.toFixed(2).split('.')[1]}
                        </span>
                        )
                     </div>
                  )}
               </div>
            ),
            accessor: 'pendingamt',
         },
         {
            id: 'pendingstatus',
            header: 'Payment Status',
            accessor: 'pendingstatus',
         },
         { id: 'createdu', header: 'Created By', accessor: 'createdu' },
         { id: 'updatedu', header: 'Updated By', accessor: 'updatedu' },
         { id: 'status', header: 'STATUS', accessor: 'status' },
      ],
      [],
   );
   const [filters, setFilters] = useState({
      pendingstatus: 'all',
      invoiceBook: 'all',
      duration: 'any',
      contact: '',
      item: '',
      daybookId: '',
      daybookIds: '',
      accountIds: '',
      accountId: '',
      fromDate: '',
      toDate: '',
   });

   const handleApplyFilters = (newFilters) => {
      setFilters(newFilters);
      let count = 0;
      if (newFilters.pendingstatus !== 'all') count++;
      if (newFilters.invoiceBook !== 'all') count++;
      if (newFilters.duration !== 'any') count++;
      if (newFilters.contact) count++;
      if (newFilters.item) count++;
      if (newFilters.daybookId) count++;
      if (newFilters.daybookIds) count++;
      if (newFilters.accountIds) count++;
      if (newFilters.accountId) count++;
      if (newFilters.fromDate) count++;
      if (newFilters.toDate) count++;
      setCurrentPage(1);
   };
   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      ?.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const wrapperRef = useRef();

   const filteredData = useFilterData(data, debouncedSearchQuery, columns);

   const handlePageChange = useCallback(
      (directionOrPage) => {
         if (typeof directionOrPage === 'number') {
            setCurrentPage(directionOrPage);
         } else {
            setCurrentPage((prevPage) => {
               if (directionOrPage === 'next') {
                  return prevPage < pagination?.totalPages ? prevPage + 1 : prevPage;
               } else {
                  return prevPage > 1 ? prevPage - 1 : prevPage;
               }
            });
         }
      },
      [pagination?.totalPages],
   );

   function EditSyncRecord(id) {
      let formdata = {
         id,
         status: true,
      };
      const sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
      const sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
      dispatch(updateSyncPurchaseInvoice(formdata)).then(() => {
         dispatch(
            getPurchaseInvoices({
               page: currentPage,
               limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               sortBy,
               sortOrder,
               paymentStatus: filters.paymentStatus !== 'all' ? filters.paymentStatus : undefined,
               invoiceBook: filters.invoiceBook !== 'all' ? filters.invoiceBook : undefined,
               duration: filters.duration !== 'any' ? filters.duration : undefined,
               contact: filters.contact || undefined,
               item: filters.item || undefined,
               daybookId: filters.daybookId || undefined,
               daybookIds: filters.daybookIds || undefined,
               accountIds: filters.accountIds || undefined,
               accountId: filters.accountId || undefined,
               fromDate: filters.fromDate || undefined,
               toDate: filters.toDate || undefined,
               status: false, // Keep this to only show unsynced records
               isSync: true,
            }),
         );
      });
   }

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);
      setLimit(newLimit);
      setCurrentPage(1);
   };

   const deletePurchase = () => {
      deleteRecord(viewDetail?.id, deletePurchaseInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      onClose();
   };
   const handleViewSingleData = async (id) => {
      await dispatch(getPurchaseInvoice(id));
      setIsOpenSingleView(true);

      const currentIdx = purchaseInvoice.findIndex((x) => x.id === id);
      const prevObject = currentIdx > 0 ? purchaseInvoice[currentIdx - 1] : null;
      const nextObject = currentIdx < purchaseInvoice.length - 1 ? purchaseInvoice[currentIdx + 1] : null;

      await dispatch(
         getSinglePurchaseWithPrevAndNext({
            id: id,
            page: 1,
            limit: 1,
            sortBy: 'id',
            sortOrder: 'desc',
         }),
      );
      setPaginateData({
         hasPreviousPage: prevObject ? true : false,
         previousPage: prevObject ? currentIdx - 1 : null,
         nextPage: nextObject ? currentIdx + 1 : null,
         hasNextPage: nextObject ? true : false,
      });
      onOpen();
   };

   const handlePrevPage = useCallback(
      async (page) => {
         await dispatch(
            getSinglePurchaseWithPrevAndNext({
               page: page,
               limit: 1,
               sortBy: 'id',
               sortOrder: 'desc',
            }),
         );
      },
      [dispatch],
   );
   const handleNextPage = useCallback(
      async (page) => {
         await dispatch(
            getSinglePurchaseWithPrevAndNext({
               page: page,
               limit: 1,
               sortBy: 'id',
               sortOrder: 'desc',
            }),
         );
      },
      [dispatch],
   );

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const handleOnClose = useCallback(() => {
      dispatch(emptyPurchase());
      onClose(true);
   }, [dispatch, onClose]);

   const handleOnCloseBillToBill = useCallback(() => {
      setAccountId(null);
      setCompanyId(null);
      onCloseBillToBillModal();
   }, [onCloseBillToBillModal]);

   const getPurchase = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         let sortBy = sorting.length > 0 ? sorting[0]?.id : 'id';
         let sortOrder = sorting.length > 0 ? (sorting[0]?.desc ? 'DESC' : 'ASC') : 'DESC';
         await dispatch(
            getPurchaseInvoices({
               page: currentPage,
               limit: limit,
               search: debouncedSearchQuery,
               companyId: user?.loginhistory?.companyId,
               sortBy,
               sortOrder,
               // Add filter parameters here
               paymentStatus: filters.paymentStatus !== 'all' ? filters.paymentStatus : undefined,
               invoiceBook: filters.invoiceBook !== 'all' ? filters.invoiceBook : undefined,
               duration: filters.duration !== 'any' ? filters.duration : undefined,
               contact: filters.contact || undefined,
               item: filters.item || undefined,
               daybookId: filters.daybookId || undefined,
               daybookIds: filters.daybookIds || undefined,
               accountIds: filters.accountIds || undefined,
               accountId: filters.accountId || undefined,
               fromDate: filters.fromDate || undefined,
               toDate: filters.toDate || undefined,
               status: false,
               isSync: true,
            }),
         );
      }
   }, [
      currentPage,
      dispatch,
      filters.accountId,
      filters.contact,
      filters.fromDate,
      filters.toDate,
      filters.daybookId,
      filters.daybookIds,
      filters.accountIds,
      filters.duration,
      filters.invoiceBook,
      filters.item,
      filters.paymentStatus,
      limit,
      debouncedSearchQuery,
      sorting,
      user,
   ]);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (debouncedSearchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      getPurchase();
   }, [getPurchase]);

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   useEffect(() => {
      if (isOpenSingleView) {
         // dispatch(getAccountById({ id: singleEntity?.accountId, compId: user?.loginhistory?.companyId }));
      }
   }, [dispatch, isOpenSingleView, singleEntity?.accountId, user?.loginhistory?.companyId]);

   useEffect(() => {
      setPaginateData(paginate);
   }, [paginate]);

   useEffect(() => {
      setData(purchaseInvoice);
      return () => { };
   }, [purchaseInvoice]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };

   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   };

   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });

   return (
      <>
         <div
            className={`w-full min-h-screen px-0 overflow-x-auto relative py-2.5 ${isDark ? 'bg-gray-900' : 'bg-gray-50'
               } transition-colors duration-300`}>
            <div className="flex flex-col w-full">
               {/* Enhanced Header Section */}
               <div
                  className={`relative ${isDark
                     ? 'bg-gradient-to-r from-blue-900 to-purple-900'
                     : 'bg-gradient-to-r from-blue-600 to-cyan-500'
                     } shadow-2xl rounded-b-2xl mb-6 overflow-hidden`}>
                  {/* Animated background elements */}
                  <div className="absolute inset-0 bg-black/10"></div>
                  <div className="absolute top-0 left-0 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
                  <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>

                  <div
                     className={`flex ${isMobileOrTablet ? 'flex-col' : 'flex-row'
                        } justify-between items-center px-8 py-6 gap-6 relative z-10`}>
                     {/* Left Section - Enhanced Title and Back Button */}
                     <div className="flex items-center gap-4 flex-shrink-0">
                        <Link to="/admin/utility">
                           <button
                              className={`p-3 rounded-2xl backdrop-blur-sm border ${isDark
                                 ? 'bg-white/10 border-white/20 text-white hover:bg-white/20'
                                 : 'bg-white/20 border-white/30 text-white hover:bg-white/30'
                                 } shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300`}>
                              <IoMdArrowRoundBack size={20} />
                           </button>
                        </Link>
                        <div className="flex flex-col">
                           <h1 className="text-2xl font-bold text-white mb-1">Synced Un-Approved Entry</h1>
                           <div className={`h-1 w-16 rounded-full ${isDark ? 'bg-cyan-400' : 'bg-white'}`}></div>
                        </div>
                     </div>

                     {/* Right Section - Enhanced Controls */}
                     <div className="flex items-center gap-4 flex-shrink-0 flex-wrap">
                        {/* Enhanced Filter and Book Icons */}
                        <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-2xl px-3 py-2 border border-white/20">
                           <button
                              onClick={onFilterOpen}
                              className={`p-2.5 rounded-xl transition-all duration-300 ${isDark
                                 ? 'bg-white/10 text-white hover:bg-white/20'
                                 : 'bg-white/20 text-white hover:bg-white/30'
                                 } transform hover:scale-110`}>
                              <IoFilterOutline size={22} />
                           </button>
                           <button
                              onClick={() => navigate('/admin/purchase/invoice/managedaybook')}
                              className={`p-2.5 rounded-xl transition-all duration-300 ${isDark
                                 ? 'bg-white/10 text-white hover:bg-white/20'
                                 : 'bg-white/20 text-white hover:bg-white/30'
                                 } transform hover:scale-110`}>
                              <AiTwotoneBook size={22} />
                           </button>
                        </div>

                        {/* Enhanced Pagination Controls */}
                        <div className="flex items-center gap-1 bg-white/10 backdrop-blur-sm rounded-2xl px-4 py-2 border border-white/20">
                           <button
                              onClick={() => handlePageChange('prev')}
                              disabled={currentPage <= 1}
                              className={`p-2 rounded-xl transition-all ${currentPage > 1
                                 ? 'cursor-pointer opacity-100 hover:bg-white/20 transform hover:scale-110'
                                 : 'cursor-not-allowed opacity-40'
                                 } text-white`}>
                              <MdNavigateBefore size={26} />
                           </button>

                           {/* Enhanced Page Display */}
                           <div className="flex items-center mx-3 relative">
                              {!isEditingPage ? (
                                 <div className="flex items-center">
                                    <button
                                       onClick={handlePageClick}
                                       className={`min-w-[50px] text-center font-semibold px-3 py-2 rounded-xl transition-all ${isDark
                                          ? 'bg-cyan-500 text-white hover:bg-cyan-600'
                                          : 'bg-white text-blue-600 hover:bg-blue-50'
                                          } shadow-lg transform hover:scale-105`}>
                                       {currentPage}
                                    </button>
                                    <span className="mx-3 text-white font-medium">/</span>
                                    <span className="text-white font-semibold">{pagination?.totalPages || 1}</span>
                                 </div>
                              ) : (
                                 <div className="flex items-center">
                                    <input
                                       type="number"
                                       min={1}
                                       max={pagination?.totalPages || 1}
                                       value={pageInputValue}
                                       onChange={(e) => setPageInputValue(e.target.value)}
                                       onBlur={handlePageInputBlur}
                                       onKeyDown={handlePageKeyDown}
                                       className="w-14 text-center font-semibold border-2 border-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-300 rounded-xl px-2 py-1 bg-white/20 text-white"
                                       autoFocus
                                    />
                                    <span className="mx-3 text-white font-medium">/</span>
                                    <span className="text-white font-semibold">{pagination?.totalPages || 1}</span>
                                 </div>
                              )}
                           </div>

                           <button
                              onClick={() => handlePageChange('next')}
                              disabled={currentPage >= (pagination?.totalPages || 1)}
                              className={`p-2 rounded-xl transition-all ${currentPage < (pagination?.totalPages || 1)
                                 ? 'cursor-pointer opacity-100 hover:bg-white/20 transform hover:scale-110'
                                 : 'cursor-not-allowed opacity-40'
                                 } text-white`}>
                              <MdNavigateNext size={26} />
                           </button>
                        </div>

                        {/* Enhanced Page Size Select */}
                        <select
                           value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
                           onChange={(e) => {
                              const newLimit = e.target.value === 'ALL' ? totalCount : Number(e.target.value);
                              setLimit(newLimit);
                              setCurrentPage(1);
                           }}
                           className={`h-11 px-4 rounded-2xl border-2 font-medium backdrop-blur-sm ${isDark
                              ? 'bg-white/10 border-white/20 text-white'
                              : 'bg-white/20 border-white/30 text-white'
                              } focus:outline-none focus:ring-2 focus:ring-white/50 transition-all`}>
                           <option value="10" className="text-gray-800">
                              10
                           </option>
                           <option value="20" className="text-gray-800">
                              20
                           </option>
                           <option value="30" className="text-gray-800">
                              30
                           </option>
                           <option value="ALL" className="text-gray-800">
                              All
                           </option>
                        </select>

                        {/* Enhanced Search Field */}
                        <MotionFlex
                           ref={wrapperRef}
                           align="center"
                           className={`rounded-2xl cursor-pointer px-4 h-11 transition-all duration-500 backdrop-blur-sm border ${isDark
                              ? 'bg-white/10 border-white/20 hover:bg-white/15'
                              : 'bg-white/20 border-white/30 hover:bg-white/25'
                              } ${expanded ? 'w-64' : 'w-11'} overflow-hidden`}
                           onClick={() => setExpanded(true)}>
                           <MotionSearchIcon
                              className="text-white"
                              animate={{ rotate: expanded ? 0 : 90 }}
                              transition={{ duration: 0.3 }}
                           />
                           {expanded && (
                              <input
                                 type="text"
                                 placeholder="Search..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 className="bg-transparent border-none outline-none w-full ml-3 text-white placeholder-white/70 font-medium"
                                 autoFocus
                              />
                           )}
                        </MotionFlex>
                     </div>
                  </div>
               </div>

               {/* Enhanced Daybook Summary */}
               <div
                  className={`mx-6 mb-6 rounded-2xl shadow-lg border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                     } transition-all duration-300`}>
                  <div className="flex flex-wrap items-center justify-center gap-4 px-6 py-4">
                     {daybookTypeData?.map(
                        (item, i) =>
                           item.totalTaxableAmount !== 0 && (
                              <React.Fragment key={i}>
                                 <div
                                    className={`flex items-center gap-2 px-4 py-2 rounded-xl border-2 ${item.totalTaxableAmount > 0
                                       ? isDark
                                          ? 'bg-green-900/30 border-green-600 text-green-400'
                                          : 'bg-green-50 border-green-200 text-green-700'
                                       : isDark
                                          ? 'bg-red-900/30 border-red-600 text-red-400'
                                          : 'bg-red-50 border-red-200 text-red-700'
                                       } transition-all duration-300`}>
                                    <span className="font-semibold">{item.daybookname}</span>
                                    <span className="font-bold">: {Math.abs(item.totalTaxableAmount)}</span>
                                    <span
                                       className={`text-xs font-medium px-2 py-1 rounded-full ${item.totalTaxableAmount > 0
                                          ? isDark
                                             ? 'bg-green-600'
                                             : 'bg-green-500 text-white'
                                          : isDark
                                             ? 'bg-red-600'
                                             : 'bg-red-500 text-white'
                                          }`}>
                                       {item.totalTaxableAmount > 0 ? 'DB' : 'CR'}
                                    </span>
                                 </div>
                                 {i < daybookTypeData.length - 1 && (
                                    <div
                                       className={`w-1 h-1 rounded-full ${isDark ? 'bg-gray-600' : 'bg-gray-300'
                                          }`}></div>
                                 )}
                              </React.Fragment>
                           ),
                     )}
                  </div>
               </div>

               {/* Enhanced Data Table Container */}
               <div className="px-6 mb-20">
                  <div
                     className={`rounded-2xl shadow-2xl overflow-hidden border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        } transition-all duration-300`}>
                     <DynamicDataTable
                        singleEntityRights={purchaseInvoiceRight}
                        table={table}
                        tableData={data}
                        emptyMessage="No Purchase Invoice data found"
                        handleViewSingleData={handleViewSingleData}
                        toggleDropdown={toggleDropdown}
                        onEditClick={(row) => {
                           EditSyncRecord(row.id);
                        }}
                        onDeleteClick={(id) => {
                           deleteRecord(id, deletePurchaseInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
                        }}
                        onBillToBillClick={(row) => {
                           setAccountId(row.accountId);
                           setCompanyId(row.companyId);
                           setInvoiceData(row);
                           onOpenBillToBillModal();
                        }}
                        canDelete={true}
                        columnVisibility={columnVisibility}
                     />
                  </div>
               </div>

               {/* Enhanced Mobile Add Button */}
               {isMobileOrTablet && (Admin || purchaseInvoiceRight?.add) && (
                  <div className="fixed bottom-6 right-6 z-50">
                     <button
                        onClick={() => navigate('/admin/purchase/invoice/add')}
                        className={`p-5 rounded-full shadow-2xl transform hover:scale-110 transition-all duration-300 ${isDark
                           ? 'bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700'
                           : 'bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600'
                           } text-white font-bold`}>
                        <span className="text-lg">+</span>
                     </button>
                  </div>
               )}
            </div>
         </div>

         {/* Modals */}
         <SalesDetails
            isOpen={isOpen}
            onClose={handleOnClose}
            title="Purchase Invoice"
            entityType="purchaseinvoice"
            singleEntity={singleEntity}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenSingleView}
            isEditFormOpen={isEditFormOpen}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasebillteams}
            onDelete={deletePurchase}
            handleSerchClose={() => console.log('')}
         />

         {/* Filter Modal */}
         <SalesInvoiceFilterModal
            entityType="purchaseinvoice"
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            onApplyFilters={handleApplyFilters}
            initialFilters={filters}
            Totals={Totals}
         />

         <TransactionDetailModal
            isOpen={isBillToBillModal}
            onClose={handleOnCloseBillToBill}
            accountId={accountId}
            companyId={companyId}
            invoiceData={invoiceData}
            type="PURCHASE"
            page={currentPage}
            limit={limit}
         />
      </>
   );
};

export default UnusedPurchaseInvoiceMaster;
